import { TabBar } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Commission,
  CommissionActive,
  Home,
  HomeActive,
  Member,
  MemberActive,
  Profile,
  ProfileActive,
  Promote,
  PromoteActive,
} from "./components";
import "./style.scss";
const Footer = () => {
  const [nowPath, setNowPath] = useState("/");
  const navigate = useNavigate();
  const { t } = useTranslation();

  const tabs = [
    {
      key: "/home",
      title: t("mobile.page.title.home"),
      icon: (active) => (active ? <HomeActive /> : <Home />),
    },
    {
      key: "/member",
      title: t("mobile.page.title.member"),
      icon: (active) => (active ? <MemberActive /> : <Member />),
    },
    {
      key: "/promote",
      title: t("mobile.page.title.promote"),
      icon: (active) => (active ? <PromoteActive /> : <Promote />),
    },
    {
      key: "/commission",
      title: t("mobile.page.title.comission"),
      icon: (active) => (active ? <CommissionActive /> : <Commission />),
    },
    {
      key: "/personal",
      title: t("mobile.page.title.mine"),
      icon: (active) => (active ? <ProfileActive /> : <Profile />),
    },
  ];
  useEffect(() => {
    setNowPath(window.location.pathname);
  }, [window.location.pathname]);

  return (
    <div className="agent-mobile-footer">
      <TabBar
        safeArea
        onChange={(key) => {
          navigate(key, { replace: true });
        }}
        activeKey={nowPath}
      >
        {tabs.map((item) => (
          <TabBar.Item key={item.key} icon={item.icon} title={item.title} badge={item.badge} />
        ))}
      </TabBar>
    </div>
  );
};

export default Footer;
